import type { PlayEventMatch, PlayEventRound } from '@court-sync/shared';

export interface PlayEventRoundTableRow {
  primary: string;
  secondary: string;
  resultLabel: string;
  scoreLabel: string;
}

export function formatPlayEventRoundTableRow(
  roundNumber: number,
  matches: PlayEventMatch[],
  round?: PlayEventRound | null,
  startsAtLabel?: string | null
): PlayEventRoundTableRow {
  const courtCount = matches.length;
  const secondaryParts = [courtCount === 1 ? '1 court' : `${courtCount} courts`];
  if (startsAtLabel) {
    secondaryParts.push(startsAtLabel);
  }

  const scoredMatches = matches.filter((match) => (match.score?.sets?.length ?? 0) > 0);
  const completedMatches = matches.filter(
    (match) => match.result !== 'unplayed' && match.result !== 'bye'
  );

  let resultLabel: string;
  if (round?.status === 'completed' || completedMatches.length === matches.length) {
    resultLabel = 'Complete';
  } else if (round?.status === 'in_progress') {
    resultLabel = 'In progress';
  } else if (completedMatches.length === 0) {
    resultLabel = 'Scheduled';
  } else {
    resultLabel = `${completedMatches.length}/${matches.length} played`;
  }

  let scoreLabel = '—';
  if (scoredMatches.length === 1 && scoredMatches[0].score?.sets) {
    scoreLabel = scoredMatches[0].score.sets.map((set) => `${set.a}-${set.b}`).join(', ');
  } else if (scoredMatches.length > 1) {
    scoreLabel = `${scoredMatches.length} courts scored`;
  }

  return {
    primary: `Round ${roundNumber}`,
    secondary: secondaryParts.join(' · '),
    resultLabel,
    scoreLabel,
  };
}
